import amplifyConfig from "../../amplifyconfiguration.json";

export const IdentityConfigs = { amplifyConfig };
